import styled from 'styled-components';

import { rem } from '../../utils';

export const StyledGrid = styled.div`
  display: flex;
  width: 100%;
  flex-wrap: wrap;
  border-width: 1px 0 0 1px;
  border-style: solid;
  border-color: ${({ theme }) => theme.Color.Neutrals.Border};
  justify-content: space-between;
  max-width: 240px;
  height: max-content;
`;

export const StyledOptionWrapper = styled.div<{ isSelected?: boolean }>`
  position: relative;
  display: flex;
  width: ${({ theme }) => rem(theme.Icon.Size.Medium)};
  height: ${({ theme }) => rem(theme.Icon.Size.Medium)};
  max-width: ${({ theme }) => rem(theme.Icon.Size.Medium)};
  align-items: center;
  justify-content: center;
  border-style: solid;
  border-color: ${({ theme }) => theme.Color.Neutrals.Border};
  border-width: ${({ isSelected }) => (isSelected ? '1px' : '0 1px 1px 0')};
  cursor: pointer;
  flex: 0 0 10%;
  text-align: center;
  vertical-align: middle;

  &:hover {
    background: ${({ theme }) => theme.Color.Neutrals.Light};
  }

  ${({ isSelected, theme }) => {
    if (isSelected) {
      return `
        border-color: ${theme.Color.Brand.Primary};
        z-index: ${theme.ZIndex.ZIndex.Elevated};
      `;
    }

    return '';
  }}
`;
